import { Flex } from '@chakra-ui/react';
import { SidebarLayout } from 'src/layouts/SidebarLayout';
import { RevisionSidebar } from '../SubmissionUpload/RevisionSidebar';
import StepHeader from '../SubmissionUpload/components/StepHeader';
import RevisionRequest from './RevisionRequest';
import { Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/pro-regular-svg-icons';
import { IRevisionRound } from '@publishing-engine/domain/models';
import { AuthorsTab } from 'src/components/Submission/MySubmission/AuthorsTab';
import { UnsubmitFeedbackAccordion } from 'src/components/Submission/MySubmission/components/feedback/UnsubmitFeedbackAccordion';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';

interface Props {
  currentStep: number;
  totalSteps: number;
  goToPreviousStep: () => void;
  goToNextStep: () => void;
  goToStep: (step: number) => void;
  onClose: () => void;
  revisionRound: IRevisionRound | undefined;
}

const AuthorInformationStep: React.FC<Props> = ({
  currentStep,
  goToStep,
  totalSteps,
  onClose,
  revisionRound,
  goToPreviousStep,
  goToNextStep
}) => {
  const {
    workflowResponse: {
      workflowData: { currentState }
    }
  } = useSubmissionData();
  const isUnsubmitted = currentState === 'unsubmitted';

  return (
    <>
      <Flex
        flexDirection="column"
        backgroundColor="surfaceSecondaryFill"
        minH="100vh"
      >
        <SidebarLayout
          sidebar={
            <RevisionSidebar
              currentStep={currentStep}
              onNavigate={step => {
                goToStep(step);
              }}
            />
          }
        >
          <StepHeader
            currentStep={currentStep + 1}
            totalSteps={totalSteps}
            heading={
              isUnsubmitted ? 'Review Author' : 'Review author information'
            }
            description={
              isUnsubmitted
                ? 'Review and edit the extracted author information to ensure all required information is included.'
                : 'Review and edit the extracted author information to ensure all required information is included.'
            }
          />
          <UnsubmitFeedbackAccordion />
          {revisionRound && <RevisionRequest revisionRound={revisionRound} />}
          <AuthorsTab showTitle={false} isUpdateRequired isRevision />
        </SidebarLayout>
      </Flex>
      <Flex
        padding={4}
        bottom={0}
        zIndex={1}
        justifyContent="center"
        position="sticky"
        bgColor="surfacePrimaryFill"
        marginX="auto"
      >
        <Flex width="100%" justifyContent="space-between">
          {/* ----- Footer Buttons ----- */}
          <Button
            variant="caution"
            onClick={() => {
              onClose();
            }}
          >
            Exit
          </Button>
          <Flex gap={4} flexDirection="row">
            <Button
              variant="secondary"
              leftIcon={<FontAwesomeIcon icon={faChevronLeft} />}
              onClick={goToPreviousStep}
            >
              Back
            </Button>
            <Button variant="primary" onClick={goToNextStep}>
              Next
              <FontAwesomeIcon icon={faChevronRight} />
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};
export default AuthorInformationStep;
